export const BACKEND: string = 'https://amaara-quiz.herokuapp.com/api';
